import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ListDropdown"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 4.5H22.5V22.5H8.25V9H1.5V1.5H19.5V4.5ZM12.75 9.75H14.25V11.25H12.75V9.75ZM15.75 9.75H21V6H9.75V21H21V20.25H15.75V18.75H21V15.75H15.75V14.25H21V11.25H15.75V9.75ZM14.25 14.25H12.75V15.75H14.25V14.25ZM14.25 18.75H12.75V20.25H14.25V18.75ZM3 7.5V3H18V4.5H8.25V7.5H3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ListDropdown.vue"]]);
